import {
  MutationState,
  useMutation,
  useMutationState,
} from '@tanstack/react-query';
import { createEVSE } from '../../api/evse.ts';
import { CreateEVSERequest } from '../../api/requests/evse-request.ts';

export interface CreateEVSEPayload {
  id: string;
}

export default function useCreateEVSE() {
  const mutation = useMutation<CreateEVSEPayload, Error, CreateEVSERequest>({
    mutationFn: createEVSE,
    mutationKey: ['mutationkey'],
  });

  const latestMutation = useMutationState({
    filters: { mutationKey: ['mutationkey'] },
  }) as MutationState<CreateEVSEPayload, Error, CreateEVSERequest>[];

  return {
    ...mutation,
    latestMutation,
  };
}
